module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'welcome') ? _c('div', {
    staticClass: "klickbox-edit-code"
  }, [_c('div', [_c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.welcome_buttons')))]), _vm._v(" "), _c('select', {
    staticClass: "klickart-select",
    on: {
      "change": function($event) {
        return _vm.stepUpdateWelcomeOption({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yes-no"
    },
    domProps: {
      "selected": _vm.step.welcome_option === 'yes-no'
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.canvas.first_value_welcome_select')) + "\n        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "start"
    },
    domProps: {
      "selected": _vm.step.welcome_option === 'start'
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.canvas.second_value_welcome_select')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.welcome_active')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.welcome_active
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateWelcomeActive({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _vm._v(" "), _c('span')])])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-566cbf22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/Welcome.vue
 ** module id = 834
 ** module chunks = 1
 **/